import React from 'react';
import {RsnButton, RsnDialog} from '~/library/ui-kit';

export interface LoginBiometryStatusDialogProps {
    title?: string;
    context?: string;
    isError?: boolean;
    onClose?: () => void;
}

export function LoginBiometryStatusModal({
    title,
    context,
    isError,
    onClose: externalOnClose,
}: LoginBiometryStatusDialogProps) {
    const {onClose} = RsnDialog.useControls();
    return (
        <RsnDialog.Window onExitEnd={externalOnClose}>
            <RsnDialog.CenteredHeader
                icon={{
                    element: <RsnDialog.StatusIcon status={isError ? 'alert' : 'check'} />,
                }}
            >
                {title}
            </RsnDialog.CenteredHeader>
            <RsnDialog.Body>{context}</RsnDialog.Body>
            <RsnDialog.Footer>
                <RsnButton.Secondary type='button' onClick={onClose}>
                    I got it
                </RsnButton.Secondary>
            </RsnDialog.Footer>
        </RsnDialog.Window>
    );
}
